/**
 * @generated SignedSource<<806c01cfceb39e027d568b396b3dab08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CurrentUser_userFragment$data = {
  readonly brandAdminProfiles: ReadonlyArray<{
    readonly brand: {
      readonly displayName: string;
      readonly id: string;
    };
    readonly id: string;
  }>;
  readonly email: string;
  readonly firstName: string;
  readonly id: string;
  readonly lastName: string;
  readonly " $fragmentType": "CurrentUser_userFragment";
};
export type CurrentUser_userFragment$key = {
  readonly " $data"?: CurrentUser_userFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurrentUser_userFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrentUser_userFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLBrandAdminProfile",
      "kind": "LinkedField",
      "name": "brandAdminProfiles",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandType",
          "kind": "LinkedField",
          "name": "brand",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserType",
  "abstractKey": null
};
})();

(node as any).hash = "53f461cf30036be1b7ea4742a09601e3";

export default node;
